import {
    Eye,
    Heart,
    ShoppingCart,
    Package,
    Star,
    MessageSquare,
} from "lucide-react";

import "./AnalyticsTab.css";

function AnalyticsTab({ food }) {

    const analytics = [
        {
            title: "Total Views",
            value: food.totalViews || 0,
            icon: <Eye size={26} />,
        },
        {
            title: "Wishlist",
            value: food.wishlistCount || 0,
            icon: <Heart size={26} />,
        },
        {
            title: "Cart Count",
            value: food.cartCount || 0,
            icon: <ShoppingCart size={26} />,
        },
        {
            title: "Orders",
            value: food.totalOrders || 0,
            icon: <Package size={26} />,
        },
        {
            title: "Rating",
            value: food.rating || 0,
            icon: <Star size={26} />,
        },
        {
            title: "Reviews",
            value: food.ratingCount || 0,
            icon: <MessageSquare size={26} />,
        },
    ];

    return (

        <div className="analytics-tab">

            <div className="analytics-grid">

                {analytics.map((item, index) => (

                    <div
                        key={index}
                        className="analytics-card"
                    >

                        <div className="analytics-icon">

                            {item.icon}

                        </div>

                        <div>

                            <h2>{item.value}</h2>

                            <p>{item.title}</p>

                        </div>

                    </div>

                ))}

            </div>

            <div className="performance-card">

                <h2>Performance Summary</h2>

                <p>

                    This section provides a quick overview of how this food
                    item is performing on the HomeFoods platform. As more
                    analytics features are added, this area can include
                    conversion rates, repeat orders, sales trends, and
                    customer engagement.

                </p>

            </div>

        </div>

    );

}

export default AnalyticsTab;